import React from 'react';
import './InfoPage.css';

function Privacy() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Política de Privacidade</h1>

        <div className="effective-date">
          Data de Vigência: 1 de novembro de 2024
        </div>

        <section className="legal-section">
          <h2>Introdução</h2>
          <p>Na Nukki, valorizamos sua privacidade e estamos comprometidos em proteger suas informações pessoais. Esta Política de Privacidade explica como coletamos, usamos, compartilhamos e protegemos informações sobre você quando você usa nossa plataforma, site e serviços.</p>
          <p>Ao usar a Nukki, você concorda com a coleta e uso de informações de acordo com esta política.</p>
        </section>

        <section className="legal-section">
          <h3>1. Informações que Coletamos</h3>

          <h4>1.1 Informações que Você Fornece</h4>
          <ul>
            <li><strong>Informações da Conta:</strong> Nome, endereço de e-mail, número de telefone, data de nascimento, foto de perfil</li>
            <li><strong>Informações do Perfil:</strong> Biografia, localização, idiomas, métodos de pagamento</li>
            <li><strong>Verificação de Identidade:</strong> Documento de identidade emitido pelo governo, fotos selfie para verificação</li>
            <li><strong>Informações de Pagamento:</strong> Conta bancária, detalhes de cartão de crédito/débito (processados com segurança por parceiros de pagamento)</li>
            <li><strong>Comunicações:</strong> Mensagens, avaliações e outros conteúdos que você compartilha na plataforma</li>
          </ul>

          <h4>1.2 Informações que Coletamos Automaticamente</h4>
          <ul>
            <li><strong>Dados de Uso:</strong> Páginas visualizadas, pesquisas, reservas, cliques e interações</li>
            <li><strong>Informações do Dispositivo:</strong> Endereço IP, tipo de navegador, sistema operacional, identificadores do dispositivo</li>
            <li><strong>Dados de Localização:</strong> Localização aproximada do endereço IP ou localização precisa se você ativar os serviços de localização</li>
            <li><strong>Cookies e Tecnologias Similares:</strong> Dados de cookies, pixels e armazenamento local</li>
            <li><strong>Dados de Registro:</strong> Registros do servidor, relatórios de erros e históricos de transações</li>
          </ul>

          <h4>1.3 Informações de Terceiros</h4>
          <ul>
            <li>Plataformas de redes sociais (se você conectar sua conta)</li>
            <li>Processadores de pagamento e instituições financeiras</li>
            <li>Serviços de verificação de identidade</li>
            <li>Provedores de verificação de antecedentes (quando permitido por lei)</li>
            <li>Parceiros de publicidade e análise</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>2. Como Usamos Suas Informações</h3>
          <p>Usamos as informações que coletamos para:</p>
          <ul>
            <li><strong>Fornecer Serviços:</strong> Habilitar reservas, processar pagamentos, facilitar comunicações</li>
            <li><strong>Gerenciamento de Conta:</strong> Criar e gerenciar sua conta, verificar identidade</li>
            <li><strong>Suporte ao Cliente:</strong> Responder a consultas e resolver problemas</li>
            <li><strong>Segurança e Proteção:</strong> Detectar fraudes, prevenir abusos, fazer cumprir nossos termos</li>
            <li><strong>Personalização:</strong> Personalizar sua experiência e fornecer recomendações relevantes</li>
            <li><strong>Comunicação:</strong> Enviar confirmações de reserva, atualizações, mensagens de marketing</li>
            <li><strong>Análise:</strong> Entender como nossa plataforma é usada e melhorar nossos serviços</li>
            <li><strong>Conformidade Legal:</strong> Cumprir obrigações legais e responder a solicitações legais</li>
            <li><strong>Marketing:</strong> Promover nossos serviços e exibir anúncios direcionados</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>3. Como Compartilhamos Suas Informações</h3>

          <h4>3.1 Com Outros Usuários</h4>
          <p>Quando você faz uma reserva ou hospeda:</p>
          <ul>
            <li>As informações do perfil são visíveis para potenciais hóspedes/anfitriões</li>
            <li>As informações de contato são compartilhadas após a confirmação da reserva</li>
            <li>Avaliações e classificações são publicamente visíveis</li>
          </ul>

          <h4>3.2 Com Provedores de Serviços</h4>
          <p>Compartilhamos dados com parceiros confiáveis que nos ajudam a operar nossa plataforma:</p>
          <ul>
            <li>Processadores de pagamento</li>
            <li>Serviços de hospedagem em nuvem</li>
            <li>Ferramentas de suporte ao cliente</li>
            <li>Provedores de análise</li>
            <li>Plataformas de marketing</li>
            <li>Serviços de verificação de identidade</li>
          </ul>

          <h4>3.3 Por Razões Legais</h4>
          <p>Podemos divulgar informações:</p>
          <ul>
            <li>Para cumprir obrigações legais (ordens judiciais, intimações)</li>
            <li>Para proteger direitos, propriedade e segurança da Nukki, usuários ou do público</li>
            <li>Para fazer cumprir nossos Termos de Serviço</li>
            <li>Em conexão com processos legais</li>
          </ul>

          <h4>3.4 Transferências de Negócios</h4>
          <p>Se a Nukki estiver envolvida em uma fusão, aquisição ou venda de ativos, suas informações podem ser transferidas para o novo proprietário.</p>

          <h4>3.5 Com Seu Consentimento</h4>
          <p>Compartilhamos informações com terceiros quando você nos dá permissão para fazê-lo.</p>
        </section>

        <section className="legal-section">
          <h3>4. Seus Direitos de Privacidade</h3>

          <h4>4.1 Acesso e Portabilidade</h4>
          <p>Você pode acessar e baixar suas informações pessoais através das configurações da sua conta.</p>

          <h4>4.2 Correção e Atualização</h4>
          <p>Você pode atualizar suas informações pessoais a qualquer momento nas configurações da sua conta.</p>

          <h4>4.3 Exclusão</h4>
          <p>Você pode solicitar a exclusão da sua conta e informações pessoais, sujeito a certas exceções (por exemplo, requisitos legais).</p>

          <h4>4.4 Oposição ao Processamento</h4>
          <p>Você pode se opor a certos tipos de processamento, incluindo comunicações de marketing.</p>

          <h4>4.5 Comunicações de Marketing</h4>
          <p>Você pode cancelar a assinatura de e-mails de marketing clicando em "cancelar inscrição" ou ajustando suas configurações de notificação.</p>

          <h4>4.6 Cookies</h4>
          <p>Você pode controlar os cookies através das configurações do seu navegador ou da nossa ferramenta de preferências de cookies.</p>
        </section>

        <section className="legal-section">
          <h3>5. Retenção de Dados</h3>
          <p>Retemos suas informações pelo tempo necessário para:</p>
          <ul>
            <li>Fornecer nossos serviços</li>
            <li>Cumprir obrigações legais</li>
            <li>Resolver disputas</li>
            <li>Fazer cumprir nossos acordos</li>
          </ul>
          <p>Depois que você fechar sua conta, podemos reter certas informações para fins legais e de segurança.</p>
        </section>

        <section className="legal-section">
          <h3>6. Segurança</h3>
          <p>Implementamos medidas de segurança padrão da indústria para proteger suas informações, incluindo:</p>
          <ul>
            <li>Criptografia de dados em trânsito e em repouso</li>
            <li>Avaliações e testes de segurança regulares</li>
            <li>Controles de acesso e autenticação</li>
            <li>Treinamento de funcionários sobre proteção de dados</li>
          </ul>
          <p>No entanto, nenhum sistema é completamente seguro. Não podemos garantir a segurança absoluta de suas informações.</p>
        </section>

        <section className="legal-section">
          <h3>7. Transferências Internacionais de Dados</h3>
          <p>A Nukki opera globalmente. Suas informações podem ser transferidas e processadas em países diferentes do seu. Garantimos que as salvaguardas apropriadas estejam em vigor para transferências internacionais.</p>
        </section>

        <section className="legal-section">
          <h3>8. Privacidade de Crianças</h3>
          <p>A Nukki não se destina a crianças menores de 18 anos. Não coletamos intencionalmente informações de crianças. Se soubermos que coletamos informações de uma criança, iremos excluí-las prontamente.</p>
        </section>

        <section className="legal-section">
          <h3>9. Links e Serviços de Terceiros</h3>
          <p>Nossa plataforma pode conter links para sites e serviços de terceiros. Não somos responsáveis por suas práticas de privacidade. Por favor, revise suas políticas de privacidade.</p>
        </section>

        <section className="legal-section">
          <h3>10. Alterações a Esta Política</h3>
          <p>Podemos atualizar esta Política de Privacidade de tempos em tempos. Notificaremos você sobre alterações materiais por e-mail ou através da plataforma. O uso continuado após as alterações constitui aceitação da política atualizada.</p>
        </section>

        <section className="legal-section">
          <h3>11. Informações Específicas Regionais</h3>

          <h4>11.1 Usuários Europeus (GDPR)</h4>
          <p>Se você estiver no Espaço Econômico Europeu, você tem direitos adicionais sob o GDPR, incluindo:</p>
          <ul>
            <li>Direito de acessar seus dados</li>
            <li>Direito de retificação</li>
            <li>Direito de apagamento ("direito de ser esquecido")</li>
            <li>Direito de restringir o processamento</li>
            <li>Direito à portabilidade de dados</li>
            <li>Direito de oposição</li>
            <li>Direitos relacionados à tomada de decisões automatizadas</li>
          </ul>

          <h4>11.2 Usuários da Califórnia (CCPA)</h4>
          <p>Residentes da Califórnia têm direitos sob a Lei de Privacidade do Consumidor da Califórnia, incluindo:</p>
          <ul>
            <li>Direito de saber quais informações pessoais são coletadas</li>
            <li>Direito de saber se as informações pessoais são vendidas ou divulgadas</li>
            <li>Direito de optar por não vender informações pessoais</li>
            <li>Direito de exclusão</li>
            <li>Direito de não discriminação</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>12. Entre em Contato Conosco</h3>
          <p>Se você tiver dúvidas sobre esta Política de Privacidade ou nossas práticas de privacidade, entre em contato conosco:</p>
          <div className="feature-box">
            <p><strong>E-mail:</strong> privacy@nukki.com</p>
            <p><strong>Endereço:</strong> Equipe de Privacidade da Nukki<br/>
            123 Market Street<br/>
            San Francisco, CA 94103</p>
            <p><strong>Encarregado de Proteção de Dados:</strong> dpo@nukki.com</p>
          </div>
        </section>

        <section className="legal-section">
          <p><em>Última atualização: 1 de novembro de 2024</em></p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
